import BasicHeader from './BasicHeader';

export default BasicHeader;
